import { useTableContext } from '@/components/ui/table/table-context';

import { useDocumentHighlight } from './useDocumentHighlight';

interface TableEffectsProps<TData extends { document_id: string | null }> {
  data: TData[];
}

/**
 * Runs the collections document tables' table-dependent side effects inside <DataTable.Root>, where
 * the table instance is reachable via context (the Toolbar render-prop can't run hooks). Shared by
 * DatasourcesDocumentsTable and ContentTable.
 *
 * The reactive part — which document the URL hash targets — is read at the parent via
 * `useHashDocumentId` and fed to `activeRowId`; this component only owns the imperative effects.
 * (The search-driven page reset lives in the toolbar's search `onChange`, not here — it's a direct
 * response to a user action, so it belongs in the event handler.)
 */
export function TableEffects<TData extends { document_id: string | null }>({
  data,
}: TableEffectsProps<TData>) {
  const { table, resourceName } = useTableContext<TData>();

  useDocumentHighlight({ table, data, resourceName });

  return null;
}
